import useOnHover from 'hooks/useOnHover'
import useThemeColors from 'hooks/useThemeColors'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { CTAType, Message } from 'types/message'
import { broadcast } from 'utils/message'
import { shadeHexColor } from 'utils/styles'

import './style.css'

interface CtaButtonProps {
  ctaUrl: string,
  ctaCopy: string,
  ctaType: CTAType,
  onClick?: Function,
  ariaHidden?: boolean
}

const CtaButton = ({ ctaUrl, ctaCopy, ctaType, onClick, ariaHidden }: CtaButtonProps) => {
  const { hoverProps, isHovered } = useOnHover()

  const { backgroundStyles } = useThemeColors()
  const activeCampaign: Message = useSelector(state => state.campaigns.activeCampaign)

  const background = useMemo(() => {
    const newBackground = isHovered
      ? shadeHexColor(backgroundStyles.background as string, -5)
      : backgroundStyles.background

    return {
      ...backgroundStyles,
      background: newBackground
    }
  }, [backgroundStyles, isHovered])

  const onCtaClick = (event) => {
    if (ctaType === CTAType.CHAT_RESPONSE) {
      broadcast({
        topic: 'drift-api:open-chat'
      })
    } else if (ctaType === CTAType.SCHEDULE_MEETING) {
      broadcast({
        topic: 'drift-api:schedule-meeting',
        message: {
          scheduleMeetingWith: activeCampaign.attributes.senderId,
          options: {
            activeCampaign
          }
        }
      })
    }

    onClick && onClick(event)
  }

  if (ctaType === CTAType.LINK_TO_URL) {
    return (
      <div
        className="drift-widget-announcement-cta drift-widget-announcement-cta-link-wrapper"
        hidden={ariaHidden}
      >
        <a
          className="drift-widget-announcement-cta-link"
          href={ctaUrl}
          onClick={onCtaClick}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${ctaCopy}; opens an external site in a new window`}
          style={background}
          aria-hidden={ariaHidden}
          {...hoverProps}
        >
          {ctaCopy}
        </a>
      </div>
    )
  }

  return (
    <button
      className="drift-widget-announcement-cta"
      onClick={onCtaClick}
      style={background}
      {...hoverProps}
    >
      {ctaCopy}
    </button>
  )
}

export default CtaButton
